import { UserBackend } from './user-backend';

export class User {

    email: string;
    token?: string;

    userGoogle?: any;
    userBackend?: UserBackend;

    constructor() {
        this.userBackend = new UserBackend();
    }

}